/**
 * Shuffle an array in place using Fisher-Yates algorithm
 * @param array The array to shuffle
 * @returns The shuffled array (same reference)
 */
export function shuffle<T>(array: Array<T>): Array<T> {
  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    const randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }

  return array;
}
